module.exports = __webpack_public_path__ + "static/media/the-promised-land.d34bd1f8.jpg";